export const TOKEN_NAME = 'token-v2'
